/**
 * ProtectedImage
 *
 * Wraps an <img> with a subtle always-visible copyright watermark in the
 * bottom-right corner. Use for founder / coach / signature photos to signal
 * ownership. Also inherits the site-wide right-click and drag-save blockers
 * from App.js.
 *
 * Usage:
 *   <ProtectedImage src="/assets/ashutosh-pandey.png" alt="..." />
 *
 * Optional props:
 *   watermark   – override the default "© NextChapter4You.nl" text
 *   position    – "br" (default), "bl", "tr", "tl"
 *   className   – forwarded to the outer wrapper
 *   imgClassName – forwarded to the <img>
 */

const POSITION_CLASSES = {
  br: "bottom-2 right-3",
  bl: "bottom-2 left-3",
  tr: "top-2 right-3",
  tl: "top-2 left-3",
};

export default function ProtectedImage({
  src,
  alt,
  watermark = "© NextChapter4You.nl",
  position = "br",
  className = "",
  imgClassName = "w-full h-full object-cover",
  loading = "lazy",
  ...rest
}) {
  return (
    <div className={`relative w-full h-full ${className}`} data-testid="protected-image">
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={imgClassName}
        {...rest}
      />
      {watermark && (
        <div
          aria-hidden="true"
          className={`absolute ${POSITION_CLASSES[position] || POSITION_CLASSES.br} pointer-events-none select-none`}
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "13px",
            fontWeight: 500,
            letterSpacing: "0.08em",
            color: "rgba(255, 255, 255, 0.85)",
            textShadow: "0 1px 3px rgba(0,0,0,0.7), 0 0 8px rgba(0,0,0,0.45)",
            background: "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(30,39,97,0.35) 100%)",
            padding: "3px 10px",
            borderLeft: "2px solid #C9A84C",
          }}
        >
          {watermark}
        </div>
      )}
    </div>
  );
}
